// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { SpinningIcon as BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <defs>
      <linearGradient id="jfeio7pd">
        <stop offset="10%" stopColor="currentColor" stopOpacity="0" />
        <stop offset="90%" stopColor="currentColor" />
      </linearGradient>
    </defs>
    <path d="M12 4a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 18a10 10 0 1 1 10-10 10 10 0 0 1-10 10Z" opacity=".1" />
    <path fill="url(#jfeio7pd)" d="M4 12a8 8 0 0 1 16 0 1 1 0 0 0 2 0 10 10 0 0 0-20 0Z" />
  </BaseIcon>
)
